function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#67BBB0",
  d: "M0,80C0,35.817,35.816,0,80,0c44.183,0,80,35.817,80,80c0,44.183-35.817,80-80,80C35.816,160,0,124.183,0,80 "
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 50.784,
  y: 43.15,
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 5.107,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  width: 58.432,
  height: 73.701
});

var _ref4 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 5.107,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 87.506,
  y1: 54.216,
  x2: 97.964,
  y2: 54.216
});

var _ref5 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 5.107,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 87.506,
  y1: 67.048,
  x2: 97.964,
  y2: 67.048
});

var _ref6 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 5.107,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 62.036,
  y1: 92.713,
  x2: 97.964,
  y2: 92.713
});

var _ref7 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 5.107,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 62.036,
  y1: 79.881,
  x2: 97.964,
  y2: 79.881
});

var _ref8 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 5.107,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 62.036,
  y1: 105.545,
  x2: 97.964,
  y2: 105.545
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 62.036,
  y: 54.16,
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 5.107,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  width: 14,
  height: 12.888
});

var SvgInformativeAccent = function SvgInformativeAccent(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "-0.202 -0.518 161 161",
    enableBackground: "new -0.202 -0.518 161 161",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInformativeAccent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/informative_accent.a26626ce.svg";
export { ForwardRef as ReactComponent };